<template>
  <v-app >
      <v-app-bar app color="primary">
            <v-toolbar-title class="headline text-uppercase">
                <span>Fame</span>
                <span class="font-weight-light"> MADE SENSE</span>
            </v-toolbar-title>
            <v-spacer></v-spacer>
            <!-- This button needs to toggle the search filter drawer. -->
            <v-btn
            color="accent"
            icon
            @click.stop="drawer = !drawer"
            >
                <v-icon large>mdi-card-search</v-icon>
            </v-btn>
        </v-app-bar>
    <v-content class="mt-6">
        <Navigation/>
        <NavSearch/>
        <router-view/>
    </v-content>
  </v-app>
</template>

<script>
import Navigation from './components/Navigation.vue'
import NavSearch from './components/NavSearch.vue'

export default {
  name: 'App',
  components: {
      Navigation,
      NavSearch
  },
  data: () => ({
    //
  })
};
</script>
